import React from 'react';
import LicenseInformationCard from 'components/@common/LicenseInformationCard';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { UserLicenseUsage } from 'types/schema-generated-types';
import { getAssignedProducts, getId } from 'utilities/product-utils';

const useStyles = makeStyles(theme => ({
  root: { padding: theme.spacing(3) },
  title: { marginBottom: theme.spacing(1) },
  licenseCardContainer: {
    display: 'grid',
    gridGap: 8,
    gridAutoRows: '1fr',
    gridAutoFlow: 'dense'
  }
}));

export interface UserLicenseInformationProps {
  licenseUsage: UserLicenseUsage[];
  emptyMessage?: string;
}

const UserLicenseInformation: React.FC<UserLicenseInformationProps> = ({
  licenseUsage = [],
  emptyMessage
}) => {
  const classes = useStyles();
  const productLicenses = getAssignedProducts(licenseUsage, false);

  return (
    <Paper className={classes.root} elevation={3}>
      <Typography variant="h2" className={classes.title}>
        Assigned Teacher Licenses
      </Typography>
      {productLicenses.length === 0 && <Typography>{emptyMessage}</Typography>}
      <div className={classes.licenseCardContainer}>
        {productLicenses.map(({ product, productCurriculum }) => (
          <LicenseInformationCard
            key={`license_${getId(product, productCurriculum)}`}
            product={product}
            productCurriculum={productCurriculum}
          />
        ))}
      </div>
    </Paper>
  );
};

export default UserLicenseInformation;
